import { render } from "./Bloggertrip.vue?vue&type=template&id=0480abe4"
import script from "./Bloggertrip.vue?vue&type=script&lang=js"
export * from "./Bloggertrip.vue?vue&type=script&lang=js"

import "./Bloggertrip.vue?vue&type=style&index=0&id=0480abe4&lang=css"

import exportComponent from "D:\\curProject\\newTrip\\client\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__